/** @type {import('../help-index.js').HelpSidebarItem} */
export const TAX_PER_EXCLUSIONS_ITEM = {
  id: 'perception_exclusions',
  screenId: 'tax-per-exclusions',
  label: 'Exclusiones',
  description: 'Clientes exentos de percepción por impuesto y período.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Registrás clientes que no deben sufrir percepción de un impuesto determinado, total o por un rango de fechas (certificado de exclusión).',
      },
      {
        title: 'Paso 1 — Filtrar y ver la lista',
        fields: [
          { label: 'Solo activas', description: 'Interruptor para ocultar exclusiones vencidas o desactivadas.' },
          { label: 'Impuesto', description: 'Filtrá por un impuesto agente o dejá «Todos (agente)».' },
        ],
        bullets: [
          'Columnas: Impuesto, Cliente, Desde, Hasta, Activo.',
          'Tocá una fila para editar. Botón + para nueva exclusión.',
        ],
      },
      {
        title: 'Paso 2 — Nueva exclusión',
        fields: [
          { label: 'Impuesto', description: 'Solo impuestos configurados como agente de percepción.' },
          { label: 'Cliente', description: 'Buscador por nombre o documento (mín. 3 caracteres).' },
          { label: 'Desde / Hasta', description: 'Vigencia opcional. Vacío = sin límite en esa fecha.' },
        ],
      },
    ],
  },
}
